import { useEffect, useRef } from "react";

let scriptPromise;

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-coa-turnstile="true"]');
    const script = existing || document.createElement("script");
    if (!existing) {
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.dataset.coaTurnstile = "true";
      document.head.appendChild(script);
    }
    script.addEventListener("load", () => resolve(window.turnstile), { once: true });
    script.addEventListener("error", () => reject(new Error("Security verification could not be loaded.")), { once: true });
  });
  return scriptPromise;
}

export function TurnstileWidget({ siteKey, action = "request_board_access", onToken, onError, resetKey }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!siteKey) {
      onError("Security verification is not configured.");
      return undefined;
    }

    let disposed = false;
    let widgetId;
    onToken("");

    loadTurnstile()
      .then((turnstile) => {
        if (disposed || !containerRef.current) return;
        widgetId = turnstile.render(containerRef.current, {
          sitekey: siteKey,
          action,
          appearance: "always",
          size: "flexible",
          theme: "light",
          callback: (token) => onToken(token),
          "expired-callback": () => onToken(""),
          "timeout-callback": () => onToken(""),
          "error-callback": () => {
            onToken("");
            onError("Security verification could not be completed. Please retry.");
          },
        });
      })
      .catch((error) => onError(error.message || "Security verification could not be loaded."));

    return () => {
      disposed = true;
      if (widgetId !== undefined && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [siteKey, action, onToken, onError, resetKey]);

  return <div className="turnstile-container" ref={containerRef} aria-label="Security verification" />;
}
